import module from 'kendu/legacy/module'
import './style.scss'

function gridDirective ($cacheFactory, $kdStyles) {
  let gridTemplateCache = $cacheFactory('kdGridTemplate')
  let gridGapCache = $cacheFactory('kdGridGap')

  function getTemplateSelector (value) {
    return gridTemplateCache.get(value) || createTemplateSelector(value, gridTemplateCache.info().size)
  }

  function getGapSelector (value) {
    return gridGapCache.get(value) || createGapSelector(value, gridGapCache.info().size)
  }

  function createTemplateSelector (value, name) {
    const selector = `grid--template-${name}`

    $kdStyles.media().insertRule(`[grid="${value}"]`, {'grid-template-columns': value})

    gridTemplateCache.put(value, selector)

    return selector
  }

  function createGapSelector (value, name) {
    const selector = `grid--gap-${name}`

    $kdStyles.media().insertRule(`[grid-gap="${value}"]`, {'grid-gap': value})

    gridGapCache.put(value, selector)

    return selector
  }

  return {
    restrict: 'A',
    link (scope, element, attrs) {
      let classes = ['grid']

      if (!attrs.grid) return

      let templateId = getTemplateSelector(attrs.grid)

      classes.push(templateId)

      if (attrs.gridGap) {
        let gapId = getGapSelector(attrs.gridGap)

        classes.push(gapId)
      }
    },
  }
}

module.directive('grid', gridDirective)



// WEBPACK FOOTER //
// ./src/deprecated/directive/grid/component.js